<template>
    <div>
        <v-dialog v-model="$root.driveAlert" persistent no-click-animation max-width="600">
            <v-card>
                <v-card-title class="title noshadow redcolor font18 pr-0">
                    <v-icon class="redcolor mr-3">warning</v-icon>Set Auto Data Backup Now
                    <v-spacer></v-spacer>
                    <!-- <v-menu style="z-index: 999;">
                        <v-btn small slot="activator" icon><v-icon>more_horiz</v-icon></v-btn>
                        <v-list dense nopadding>
                            <v-list-tile @click="fn_watchHelpVideo">
                                <v-list-tile-title>Watch Help Video</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu> -->
                </v-card-title>
                <v-card-text class="pt-0 font16">
                    <div class="mt-4 mb-4">To setup go to <strong>Bizops Mobile App > Settings > Data Backup</strong></div>
                    <ul style="line-height: 32px;list-style-type: '\2713   ';">
                        <li>Your data will be <span greencolor font-medium>Safe</span> and <span greencolor font-medium>Secure</span>.</li>
                        <li>Keep it on your <span primary-color font-medium>Personal</span> email drive.</li>
                        <li>Data will be backed up <span greencolor font-medium>Automatically</span>.</li>
                        <li>No <span style="color: #fb8c00;" font-medium>Manual</span> backups required.</li>
                        <li><span primary-color font-medium>Restore</span> from your email drive anytime.</li>
                    </ul>

                    <v-alert type="info" :value="true" v-if="this.driveMessage" class="mt-4">{{ this.driveMessage }}</v-alert>
                </v-card-text>
                <v-card-actions style="padding-bottom: 16px;">
                    <v-layout ma-0 row wrap>
                        <!-- <v-flex xs12 sm12 md12 center-align pl-3 pr-3>
                            <v-btn font-heavy color="primary" block @click="gotoSetupDrive">Setup Now</v-btn>
                        </v-flex> -->
                        <!-- <v-flex xs12 sm12 md12 center-align pl-3 pr-3 mt-3 v-if="transactionCount < 10">
                            <v-btn font-heavy light-opacity-color flat block @click="fn_close">Skip</v-btn>
                        </v-flex> -->
                        <v-flex xs12 sm12 md12 right-align pr-3 font12 light-opacity-color>
                            <em>Press continue after setup drive</em>
                        </v-flex>
                        <v-flex xs6 sm6 md6 center-align pl-3 pr-3 mt-3>
                            <v-btn capitalize color="primary" text @click="fn_redirectToWhatsApp"><v-icon class="primary-color font20 mr-2">help_outline</v-icon> Contact Support</v-btn>
                        </v-flex>
                        <v-flex xs6 sm6 md6 center-align pl-3 pr-3 mt-3>
                            <v-btn capitalize color="primary" block @click="fn_checkDataDrive">Continue <v-icon class="font20 ml-2">keyboard_arrow_right</v-icon></v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default{
	props:['gotoSetupDrive', 'message', 'skipAlert', 'transactionCount'],
	data(){	
		return{
			backupAlertSheet: false,
            driveMessage: "Data drive is not set up yet."
		}
	},
	methods: {
		openDialogWeb: function () {	
			this.backupAlertSheet = true;
		},
		closeDialogWeb: function () {
            this.backupAlertSheet = false;
		},
        fn_close: function(){
            if(this.skipAlert){
                this.skipAlert();
            }
            else{
                this.closeDialogWeb();
            }
        },
		fn_watchHelpVideo: function(){
			window.open('https://www.youtube.com/watch?v=Swi0dXEjHKk&list=PLlyT7aaJmsIsicHYhxa_JWGHA0RK41yuh');
		},
        fn_redirectToWhatsApp: function(){
          window.open("https://api.whatsapp.com/send?phone=918882741212");
        },
        fn_checkDataDrive: function(){
            this.driveMessage = null;
            if(this.$root.CurrentBusiness.DataDrive){
                this.$root.driveAlert = false;
            }
            else{
                setTimeout(() => {
                    this.driveMessage = "Data drive is not set up yet.";
                }, 1000);
                // this.$eventHub.$emit('snackbarAlert', {msg:"Data drive is not set up yet."});
            }
        }
	}
}
</script>